// removed by extract-text-webpack-plugin
module.exports = {"header":"src-templates----speaker-module---header---2dPlM","headerName":"src-templates----speaker-module---headerName---fKqdX","episodeList":"src-templates----speaker-module---episodeList---3Q2mO"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/speaker.module.scss
// module id = 984
// module chunks = 120561760088751